import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=75d29936&scoped=true&"
var script = {}
import style0 from "./Hero.vue?vue&type=style&index=0&id=75d29936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d29936",
  null
  
)

export default component.exports